export enum OaScoreType {
    OA = 1,
    Area_OA,
    LOB_OA,
    Peer_Group_OA,
    Region_OA,
    Site_OA,
    Super_Group_OA,
    Other,
    Launch_OA = 20,
    Peer_Compare = 23,
}
